import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  EmployeeTransport,
  ManualShiftChanges,
} from "../../types/ganttChart";

type EditEmployeeWorkTime = {
  shiftId: number;
  workTimeStart: string | null;
  workTimeEnd: string | null;
};

type EditEmployeeTransportType = {
  shiftId: number;
  transportationType: EmployeeTransport[];
};

type EmployeeSettingSlice = {
  manualEdits: {
    [shiftId: number]: ManualShiftChanges;
  };
};

const initialState: EmployeeSettingSlice = {
  manualEdits: {},
};

const employeeSettingsSlice = createSlice({
  name: "employee-settings",
  initialState,
  reducers: {
    editEmployeeWorkTime(state, action: PayloadAction<EditEmployeeWorkTime>) {
      const { shiftId, workTimeStart, workTimeEnd } = action.payload;
      const previousEdits = state.manualEdits[shiftId] ?? {};

      state.manualEdits[shiftId] = {
        ...previousEdits,
        employeeWorkTime: {
          workTimeStart,
          workTimeEnd,
        },
      };
    },
    editEmployeeTransportType(
      state,
      action: PayloadAction<EditEmployeeTransportType>,
    ) {
      const { shiftId, transportationType } = action.payload;
      const previousEdits = state.manualEdits[shiftId] ?? {};

      state.manualEdits[shiftId] = {
        ...previousEdits,
        transportationType: transportationType,
      };
    },

    clearEmployeeWorkTimeEdit(
      state,
      action: PayloadAction<{ shiftId: number }>,
    ) {
      const { shiftId } = action.payload;
      const existingEdits = state.manualEdits[shiftId];
      if (!existingEdits) return;
      delete existingEdits.employeeWorkTime;
      delete state.manualEdits[action.payload.shiftId].employeeWorkTime;
      if (
        !existingEdits.employeeWorkTime &&
        !existingEdits.transportationType
      ) {
        delete state.manualEdits[shiftId];
      }
    },

    clearEmployeeTransportEdit(
      state,
      action: PayloadAction<{ shiftId: number }>,
    ) {
      const { shiftId } = action.payload;
      const existingEdits = state.manualEdits[shiftId];
      if (!existingEdits) return;
      delete existingEdits.transportationType;
      if (
        !existingEdits.employeeWorkTime &&
        !existingEdits.transportationType
      ) {
        delete state.manualEdits[shiftId];
      }
    },

    clearManualEdits(state) {
      state.manualEdits = {};
    },
  },
});

export const {
  editEmployeeWorkTime,
  clearEmployeeWorkTimeEdit,
  clearManualEdits,
  editEmployeeTransportType,
  clearEmployeeTransportEdit,
} = employeeSettingsSlice.actions;
export default employeeSettingsSlice.reducer;
